import { render, staticRenderFns } from "./dialogWindow.vue?vue&type=template&id=9c6f6f40&"
import script from "./dialogWindow.vue?vue&type=script&lang=js&"
export * from "./dialogWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports